import {Component} from "react";
import PropTypes from "prop-types";
import * as Grid from "../utils/grid";
import {qs} from "../utils";

const parseCookies = (cookies) => {
	let obj = {};
	let pairs = cookies.split(/ *; */);
	if ('' === pairs[0]) return obj;
	for (let i = 0; i < pairs.length; ++i) {
		let pair = pairs[i].split('=');
		obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1])
	}
	return obj;
};

class BaseGrid extends Component {

	constructor(props) {
		super(props);

		this.onPageChange = this.onPageChange.bind(this);
		this.onSortChange = this.onSortChange.bind(this);
		this.onFilterChange = this.onFilterChange.bind(this);
		this.onFilterReset = this.onFilterReset.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSelectChange = this.handleSelectChange.bind(this);
		this.renderPaginationShowsTotal = this.renderPaginationShowsTotal.bind(this);

		this.state = {
			filter: Object.assign({}, this.getDefaultFilter())
		}
	}

	getDefaultPageRows() {
		const cookies = document.cookie;
		if (cookies) {
			const parsed = parseCookies(cookies);
			if (parsed["pageRows"]) {
				const rows = 1 * parsed["pageRows"];
				if (rows > 0 && rows <= 1000) {
					return rows
				}
			}
		}
		return 15
	}

	getDefaultFilter() {
		return {
			"search": "",
			"start": 0,
			"rows": this.getDefaultPageRows()
		}
	}

	componentWillMount() {
		const {location} = this.props;
		let filter = Object.assign({}, this.state.filter, this.props.filter);
		Object.keys(filter).forEach((k) => {
			if (this.state.filter[k] === undefined) {
				console.log("Discarding extra filter " + k + " (" + filter[k] + ")")
				filter[k] = undefined;
			}
		});

		if (location && location.search) {
			filter = Object.assign(filter, qs.parse(location.search, { arrayFormat: 'bracket', encode: false }));
		}

		this.setState({filter: filter}, () => {
			this.props.onFetchData(filter)
		});
	}

	componentWillReceiveProps(nextProps) {
		const {location} = this.props;
		let filter = Object.assign({}, this.state.filter);

		if (location && nextProps.location.search !== location.search) {
			filter = Object.assign(filter, qs.parse(nextProps.location.search, { arrayFormat: 'bracket', encode: false }));
			this.setState({filter: filter}, () => {
				this.props.onFetchData(filter);
			});
		}
	}

	componentWillUnmount() {
		this.setState({filter: {}})
	}

	renderPaginationShowsTotal(start, to, total, actionCtx = null) {
		const {isFetchingCount} = this.props;
		return Grid.renderPaginationShowsTotal(isFetchingCount, start, to, total, actionCtx)
	}

	onPageChange(page, sizePerPage) {
		const {filter} = this.state;
		filter.start = (page - 1) * sizePerPage;
		filter.rows = sizePerPage;
		this.setState({filter: filter});
		this.onFetchData(filter)
	}

	onSortChange(col, dir) {
		const {filter} = this.state;
		filter.orderCol = col;
		filter.orderDir = dir;
		this.setState({filter: filter});
		this.onFetchData(filter)
	}

	handleInputChange(e, submit = false) {
		const target = e.target || e;
		let value = target.value;
		const name = target.name;

		const {filter} = this.state;
		if (target.type === 'checkbox' && !target.checked) {
			if (filter[name] && filter[name].constructor === Array) {
				let i = filter[name].indexOf(value);
				if (i > -1) {
					filter[name].splice(i, 1)
				}
			} else {
				filter[name] = undefined
			}
		} else {
			if (filter[name] && filter[name].constructor === Array) {
				filter[name].push(value)
			} else {
				filter[name] = value
			}
		}
		this.setState({filter: filter}, () => {
			if (submit) {
				this.onFilterChange()
			}
		})
	}

	handleSelectChange(name, value, submit = false) {
		const {filter} = this.state;
		filter[name] = value;
		this.setState({filter: filter}, () => {
			if (submit) {
				this.onFilterChange()
			}
		})
	}

	onFetchData(filter) {
		const {location} = this.props;

		if (this.props.history) {
			const q = "?" + qs.stringify(filter, { arrayFormat: 'bracket', encode: false });
			if (location.search !== q) {
				this.props.history.push(location.pathname + q);
			} else {
				this.props.onFetchData(filter);
			}
		} else {
			this.props.onFetchData(filter);
		}
	}

	onFilterChange(e) {
		if (e) {
			e.preventDefault();
		}
		const {filter} = this.state;
		filter.start = 0;
		this.setState({filter: filter}, () => {
			this.onFetchData(filter)
		})
	}

	onFilterReset() {
		const {filter} = this.state;
		this.setState({filter: Object.assign(filter, this.getDefaultFilter())}, () => {
			if (this.refs.table) {
				this.refs.table.reset()
			}
			this.onFilterChange()
		})
	}
}

BaseGrid.propTypes = {
	count: PropTypes.number,
	currentPage: PropTypes.number,
	filter: PropTypes.object,
	items: PropTypes.array,
	isFetchingItems: PropTypes.bool.isRequired,
	isFetchingCount: PropTypes.bool.isRequired,
	onFetchData: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
};

export default BaseGrid



// WEBPACK FOOTER //
// ./src/components/BaseGrid.js